import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import ErrorDetailsToggle from './errorDetailsToggle';
const GeneralNotification = ({
  headerMessage: _headerMessage = '',
  message: _message = '',
  hint: _hint = '',
  technicalDetail: _technicalDetail = '',
  reference: _reference = '',
  errorCode: _errorCode = '',
  list: _list = [],
  leftButtonLabel: _leftButtonLabel = '',
  leftButtonAction: _leftButtonAction = () => {},
  middleButtonLabel: _middleButtonLabel = '',
  middleButtonAction: _middleButtonAction = () => {},
  rightButtonLabel: _rightButtonLabel = '',
  rightButtonAction: _rightButtonAction = () => {},
  messageType
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames('t-notification-general', 't-error-details-host')
}, _headerMessage.length ? /*#__PURE__*/React.createElement("span", {
  className: classnames(`tqc-notification-${messageType}-header`, 't-notification-header')
}, _headerMessage) : '', _headerMessage.length && (_list.length || _message.length) ? /*#__PURE__*/React.createElement("br", null) : '', _list.length ? /*#__PURE__*/React.createElement("ul", {
  className: "t-notification-list"
}, _list.map(i => /*#__PURE__*/React.createElement("li", {
  key: Math.random()
}, i))) : '', _message.length ? _message : '', /*#__PURE__*/React.createElement(ErrorDetailsToggle, {
  hint: _hint,
  technicalDetail: _technicalDetail,
  reference: _reference,
  errorCode: _errorCode
}), _leftButtonLabel.length || _middleButtonLabel.length || _rightButtonLabel.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)) : '', _leftButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  onClick: () => _leftButtonAction(),
  className: classnames('t-notification-button-left', `t-nbl-label-${kebabCase(_leftButtonLabel)}`)
}, _leftButtonLabel) : '', _middleButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  style: {
    marginLeft: '10px'
  },
  onClick: () => _middleButtonAction(),
  className: classnames('t-notification-button-middle', `t-nbm-label-${kebabCase(_middleButtonLabel)}`)
}, _middleButtonLabel) : '', _rightButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  style: {
    float: 'right'
  },
  onClick: () => _rightButtonAction(),
  className: classnames('t-notification-button-right', `t-nbr-label-${kebabCase(_rightButtonLabel)}`)
}, _rightButtonLabel) : '');
GeneralNotification.propTypes = {
  headerMessage: PropTypes.string,
  messageType: PropTypes.string.isRequired,
  message: PropTypes.string,
  hint: PropTypes.string,
  technicalDetail: PropTypes.string,
  reference: PropTypes.string,
  errorCode: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  leftButtonAction: PropTypes.func,
  leftButtonLabel: PropTypes.string,
  middleButtonAction: PropTypes.func,
  middleButtonLabel: PropTypes.string,
  rightButtonAction: PropTypes.func,
  rightButtonLabel: PropTypes.string
};
export default GeneralNotification;